// const utils ={
//
//
//     //判断是否移动端
//     isMobile() {
//     const userAgent = navigator.userAgent.toLowerCase();
//     return /mobile|android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
// }
//
// }
// module.exports = utils;


export default{
    install(Vue){
        //判断是否移动端
        Vue.prototype.isMobile = function(){
            const userAgent = navigator.userAgent.toLowerCase();
            return /mobile|android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
        }
        //格式化时间
        Vue.prototype.formatDateS = function (row, column) {
            if(!row[column.property]) return '';
            let date = new Date(row[column.property] * 1000)
            const Y = date.getFullYear() + '-'
            const M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-'
            const D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' '
            const h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':'
            const m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':'
            const s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
            return Y + M + D + h + m + s
        }
    }
}

